import HubMemberSelectionDialog from "./HubMemberSelectionDialog";

export default function ManageUserEnrolementDialog(props) {
    return <HubMemberSelectionDialog {...props} mode="users" />;
}
